import { Alert, AlertIcon, Box, Button, Divider, Flex, FormControl, FormLabel, HStack, IconButton, Input, Select, Stack, Text, useColorModeValue } from '@chakra-ui/react';
import { Link as DefaultLink, useNavigate } from 'react-router-dom';
import React, { useEffect } from 'react';
import { fleetType, vehicelType } from '../../types';
import { useAppDispatch, useAppSelector } from '../../hooks';

import { AppDispatch } from '../../store';
import { FiArrowLeft } from 'react-icons/fi';
import { ToastContainer } from 'react-toastify';
import { addVehicle } from '../../store/actions';
import { addVehicleFormValidation } from '../../utils';
import { useFormik } from 'formik';

export const AddVehicle = () => {

    const { company } = useAppSelector(state => state.companyReducer);
    const { fleets } = useAppSelector(state => state.fleetReducer);

    const dispatch: AppDispatch = useAppDispatch();

    const navigate = useNavigate();

    const vehicleForm = useFormik({
        initialValues: {
            make: '',
            model: '',
            year: '',
            transmission: '',
            fuel_type: '',
            color: '',
            registration_number: '',
            company_id: company?.company_id,
            fleet_type: '',
        },
        validationSchema: addVehicleFormValidation,
        validateOnBlur: true,
        onSubmit: (values: vehicelType) => {
            vehicleForm.setSubmitting(true);
            dispatch(addVehicle(values))
                .then(() => {
                    navigate('/vehicles');
                    vehicleForm.setSubmitting(false);
                })
                .catch(() => vehicleForm.setSubmitting(false));
        }
    });

    useEffect(() => {
    }, []);

    return (
        <Flex
            minH={'-webkit-fill-available'}
            align={'center'}
            justify={'center'}
            // bg={useColorModeValue('gray.50', 'gray.800')}
            py={10}
        >
            <Stack>
                <Box
                    rounded={'lg'}
                    bg={useColorModeValue('white', 'gray.700')}
                    boxShadow={'lg'}
                    p={8}>
                    <Stack spacing={4}>
                        <HStack align={'center'}>
                            <Stack>
                                <IconButton variant={'ghost'} aria-label='go back' icon={<FiArrowLeft style={{ width: '24px', height: '24px' }} />} as={DefaultLink} to='/vehicles' />
                            </Stack>
                            <Stack>
                                <Text display={'flex'} fontSize={'lg'} fontWeight='medium' textAlign={'center'}>
                                    Add new vehicle.
                                </Text>
                            </Stack>
                        </HStack>
                        <Divider />
                        <Stack mb={3}>
                            <Text textAlign={'center'} fontSize={'lg'} color={'gray.600'}>
                                To enjoy all of our cool features ✌️
                            </Text>
                        </Stack>
                        {
                            !fleets.length &&
                            <Alert status='warning' borderRadius={4}>
                                <AlertIcon />
                                You need to have fleets, to be able to add a vehicle.
                            </Alert>
                        }
                        <form onSubmit={vehicleForm.handleSubmit}>
                            <FormControl id="name" isRequired mb={vehicleForm.errors.make ? 0 : 5}>
                                <FormLabel>Make</FormLabel>
                                <Input name='make' type="text" value={vehicleForm.values.make} onChange={vehicleForm.handleChange} />
                                {vehicleForm.errors.make && <Text fontSize='sm' color='red.400'>{vehicleForm.errors.make}</Text>}
                            </FormControl>
                            <FormControl id="model" isRequired mb={vehicleForm.errors.model ? 0 : 5}>
                                <FormLabel>Model</FormLabel>
                                <Input name='model' type="text" value={vehicleForm.values.model} onChange={vehicleForm.handleChange} />
                                {vehicleForm.errors.model && <Text fontSize='sm' color='red.400'>{vehicleForm.errors.model}</Text>}
                            </FormControl>
                            <HStack>
                                <Box style={{ minWidth: '50%' }}>
                                    <FormControl id="phone" isRequired mb={vehicleForm.errors.year ? 0 : 5}>
                                        <FormLabel>Year</FormLabel>
                                        <Input name='year' type="number" value={vehicleForm.values.year} onChange={vehicleForm.handleChange} />
                                        {vehicleForm.errors.year && <Text fontSize='sm' color='red.400'>{vehicleForm.errors.year}</Text>}
                                    </FormControl>
                                </Box>
                                <Box style={{ minWidth: '50%' }}>
                                    <FormControl id="color" isRequired mb={vehicleForm.errors.color ? 0 : 5}>
                                        <FormLabel>Color</FormLabel>
                                        <Input name='color' type="text" value={vehicleForm.values.color} onChange={vehicleForm.handleChange} />
                                        {vehicleForm.errors.color && <Text fontSize='sm' color='red.400'>{vehicleForm.errors.color}</Text>}
                                    </FormControl>
                                </Box>
                            </HStack>
                            <HStack justifyContent={'space-between'}>
                                <Box style={{ minWidth: '50%' }}>
                                    <FormControl id="transmission" isRequired mb={vehicleForm.errors.transmission ? 0 : 5}>
                                        <FormLabel>Transmission</FormLabel>
                                        <Select name='transmission' placeholder='Select transmission' onChange={vehicleForm.handleChange}>
                                            <option value='manual'>Manual</option>
                                            <option value='automatic'>Automatic</option>
                                        </Select>
                                        {vehicleForm.errors.transmission && <Text fontSize='sm' color='red.400'>{vehicleForm.errors.transmission}</Text>}
                                    </FormControl>
                                </Box>
                                <Box style={{ minWidth: '50%' }}>
                                    <FormControl id="fuel_type" isRequired mb={vehicleForm.errors.fuel_type ? 0 : 5}>
                                        <FormLabel>Fuel Type</FormLabel>
                                        <Select name='fuel_type' placeholder='Select fuel type' onChange={vehicleForm.handleChange}>
                                            <option value='petrol'>Petrol</option>
                                            <option value='diesel'>Diesel</option>
                                        </Select>
                                        {vehicleForm.errors.fuel_type && <Text fontSize='sm' color='red.400'>{vehicleForm.errors.fuel_type}</Text>}
                                    </FormControl>
                                </Box>
                            </HStack>
                            <HStack>
                                <Box style={{ minWidth: '50%' }}>
                                    <FormControl id="registration_number" isRequired mb={vehicleForm.errors.registration_number ? 0 : 5}>
                                        <FormLabel>Registration number</FormLabel>
                                        <Input name='registration_number' type="text" value={vehicleForm.values.registration_number} onChange={vehicleForm.handleChange} />
                                        {vehicleForm.errors.registration_number && <Text fontSize='sm' color='red.400'>{vehicleForm.errors.registration_number}</Text>}
                                    </FormControl>
                                </Box>
                                <Box style={{ minWidth: '50%' }}>
                                    <FormControl id="fleet_type" isRequired mb={vehicleForm.errors.fleet_type ? 0 : 5}>
                                        <FormLabel>Fleet type</FormLabel>
                                        <Select name='fleet_type' value={vehicleForm.values.fleet_type} placeholder='Select fleet type' onChange={vehicleForm.handleChange} onBlur={vehicleForm.handleBlur}>
                                            {
                                                fleets?.map((fleet: fleetType, index: number) => <option value={fleet?.fleet_size} style={{ textTransform: 'capitalize' }} key={index}>{fleet?.fleet_size}</option>)
                                            }
                                        </Select>
                                        {vehicleForm.errors.fuel_type && <Text fontSize='sm' color='red.400'>{vehicleForm.errors.fuel_type}</Text>}
                                    </FormControl>
                                </Box>
                            </HStack>
                            <Stack spacing={10} pt={4}>
                                <Button
                                    type='submit'
                                    isLoading={vehicleForm.isSubmitting}
                                    isDisabled={!vehicleForm.isValid || vehicleForm.isSubmitting || !fleets?.length}
                                    size="lg"
                                    colorScheme={'yellow'}
                                >
                                    Submit
                                </Button>
                            </Stack>
                        </form>
                    </Stack>
                </Box>
            </Stack>
            <ToastContainer />
        </Flex>
    );
};